export default [
    {
        name: 'Selected',
        value: 'far fa-check-circle',
        icon: true,
        showCondition: (user) => user.selected
    },
    {
        name: 'Unit',
        value: 's_unit' 
    },
    {
        name: 'First Name',
        value: 's_first_name' 
    },
    {
        name: 'Last Name',
        value: 's_last_name' 
    },
    {
        name: 'Title',
        value: 's_job_title' 
    },
    {
        name: 'Department',
        value: 's_department' 
    }
];